<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <!-- 标题 -->
      <div ref="searchBox" class="formBox margbot">
        <!-- <div class="detailsTitle">
          <h4>天车作业日志</h4>
        </div> -->
        <!-- 查询条件 -->
        <el-form :inline="true" :model="formData" label-width="90px" size="mini" style="width: 100%;">
          <div class="formItemBox">
          <el-form-item label="起吊时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.startTime" size="mini" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
            -
            <el-date-picker v-model="formData.endTime" size="mini" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-select size="mini" clearable v-model="formData.warehouseId" placeholder="请选择" style="width:135px">
              <el-option v-for="item in cangkuData" :label="item.warehouse_name" :key="item.warehouse_id" :value="item.warehouse_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="作业类型:">
            <el-select size="mini" clearable v-model="formData.jobType" placeholder="请选择" style="width:135px">
              <el-option v-for="item in typeData" :label="item.show_name" :key="item.show_name" :value="item.item_no"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="捆包编号:">
            <el-input  class="ipt" v-model="formData.cargoCode" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
          </div>
          <el-form-item style="padding: 0 0 10px 10px;">
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--表格-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table height="100%" size="mini" ref="tabref" :data="tableData" style="width:100%" class="elTab" border :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓库" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="equipmentName" label="天车名称" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="jobType" label="作业类型" align="center">
            <template v-slot="scoped">
              <span>{{["入库","出库","理货","非法出库"][scoped.row.jobType]}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="180" prop="cargoCode" label="捆包号" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="140" prop="weight" label="吊装重量(吨）" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="220" prop="liftLocation" label="起吊位置" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="220" prop="downLocation" label="落吊位置" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="100" prop="operationTime" label="吊装时长(S)" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="220" prop="liftTime" label="起吊时间" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="220" prop="downTime" label="落吊时间" align="center"></el-table-column>
        </el-table>
        <!--分页-->
        <div class="pags" style="text-align: right;">
          <el-pagination background @current-change="handleCurrentChange" :current-page="formData.pageNo" :page-size="formData.pageSize" :page-sizes="[10, 20, 30, 40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { dateFormat1 } from '@/utils/util.js'

import { intelligenceList, queryJob } from '@/api/wms-stock'
export default {
  name: 'crownsOpperateLog',
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '500px',
      tableData: [],
      formData: {
        pageNo: 1,
        pageSize: 20,
        startTime: dateFormat1(new Date().getTime() - 7 * 24 * 60 * 60 * 1000, 'YYYY-MM-ss h-m-s'),
        endTime: dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s'),
        warehouseId: '',
        jobType: '',
        cargoCode: ''
      },
      total: 0,
      cangkuData: [],
      typeData: [
        {
          show_name: '入库',
          item_no: 0
        },
        {
          show_name: '出库',
          item_no: 1
        },
        {
          show_name: '理货',
          item_no: 2
        },
        {
          show_name: '非法出库',
          item_no: 3
        }

      ]
    }
  },
  mounted () {
    this.intelligenceListS()

    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 165 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    intelligenceListS () {
      intelligenceList().then(res => {
        this.cangkuData = res
        this.formData.warehouseId = res[0].warehouse_id
        this.chaxun()
      })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 查询
    chaxun () {
      queryJob({
        tenantId: localStorage.getItem('tenantCode'),
        ...this.formData
      })
        .then(res => {
          this.total = res.total
          this.tableData = res.list
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 重置
    chongZhi () {
      this.formData = {
        pageNo: 1,
        pageSize: 20,
        startTime: dateFormat1(new Date().getTime() - 7 * 24 * 60 * 60 * 1000, 'YYYY-MM-ss h-m-s'),
        endTime: dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s'),
        warehouseId: this.cangkuData[0].warehouse_id,
        jobType: '',
        cargoCode: ''
      }
      this.chaxun()
    },

    // 表格分页
    handleCurrentChange (val) {
      this.formData.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.formData.pageSize = val
      this.chaxun()
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/crownsOperateLog')

    // this.getOutstockCancellationRecordListS()
  }
}
</script>

<style lang="less" scoped>
   .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
